import {Component, OnInit} from '@angular/core';
import {BreadcumbsService} from "../breadcumbs/breadcumbs.service";
import {CommonService} from "../../common/common.service";

@Component({
  selector: 'pbc-agro-calc',
  templateUrl: './agro-calc.component.html',
  styleUrls: ["./agro-calc.component.scss"]
})
export class AgroCalcComponent implements OnInit {

  constructor( private breadcumbsService: BreadcumbsService, private commonService : CommonService) { }

  ngOnInit() {
    setTimeout(()=>this.breadcumbsService.setSubfolder.emit('Agrokalk'),100);
  }

  onAskForOfferClick() {
    this.commonService.registerClickOnElement('clickOnAskForOffer','externalServices', 'AGROKALK', null).subscribe(
      success => {
        if (success.status != 1)
          console.log(success.message);
      },
      error => {
        console.log(error);
      }
    );
  }

}
